import { render, staticRenderFns } from "./InvitationCredentialsForm.vue?vue&type=template&id=6af3128a&"
import script from "./InvitationCredentialsForm.vue?vue&type=script&lang=js&"
export * from "./InvitationCredentialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports